import api from './axiosConfig';

export const getUserSettings = async (userId: string) => {
  try {
    const response = await api({
      method: 'get',
      url: `/v2/user/${userId}/settings`,
    });
    return response.data;
  } catch (e) {
    console.error(e);
    return {};
  }
};

export const updateUserSettings = async (userId: string, userSettings: any) => {
  try {
    const response = await api({
      method: 'patch',
      url: `/v2/user/${userId}/settings`,
      data: [userSettings],
    });
    return response.data;
  } catch (e) {
    console.error(e);
    return {
      error: true,
      message: e.message,
    };
  }
};
